module.exports = __webpack_public_path__ + "static/media/collapsed.36cfe195.svg";